import React from 'react';

const Ojtcarriersection = () => {
  return (
    <div
      className="text-center text-white otg-card-header py-5"
     
    >
      <div className="container">
        <h2 className="fw-bold mb-3 display-5 text-white">Ready to Launch Your Career?</h2>
        <p className="lead mb-5 text-white">
          Join thousands of successful professionals who started their journey with our OJT program.<br />
          Your dream career is just one application away.
        </p>

        <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-4 col-lg-3 mb-4">
            <div className="d-flex flex-column align-items-center">
              <div
                className="rounded-circle d-flex ojt-icon-section justify-content-center align-items-center mb-3 shadow"
              
              >
                <i className="bi bi-clock fs-2 text-white"></i>
              </div>
              <h5 className="fw-bold text-white">6-Month Program</h5>
              <p className="mb-0 text-white">Intensive hands-on training</p>
            </div>
          </div>

          <div className="col-12 col-md-4 col-lg-3 mb-4">
            <div className="d-flex flex-column align-items-center">
              <div
                className="rounded-circle  ojt-icon-section d-flex justify-content-center align-items-center mb-3 shadow"
               
              >
                <i className="bi bi-people fs-2 text-white"></i>
              </div>
              <h5 className="fw-bold text-white">Expert Mentors</h5>
              <p className="mb-0 text-white">Learn from industry leaders</p>
            </div>
          </div>

          <div className="col-12 col-md-4 col-lg-3 mb-4">
            <div className="d-flex flex-column align-items-center">
              <div
                className="rounded-circle d-flex ojt-icon-section justify-content-center align-items-center mb-3 shadow"
               
              >
                <i className="bi bi-award fs-2 text-white"></i>
              </div>
              <h5 className="fw-bold text-white">Certification</h5>
              <p className="mb-0 text-white">Industry-recognized credentials</p>
            </div>
          </div>
        </div>

        {/* <div>
          <button className="btn   fw-semibold px-4 py-2 me-3">
            <i className="bi bi-person-plus me-2"></i>Apply Now
          </button>
          <button className="btn  fw-semibold px-4 py-2">
            <i className="bi bi-telephone me-2"></i>Schedule a Call
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Ojtcarriersection;
